module.exports = __webpack_public_path__ + "media/newstyle/images/icon-ebook-06cd19b12e6b1f6392dd1facd389435c.svg";